import React, { useState, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import AppBarComponent from "../components/AppBarComponent";
import { apiUrl } from "../apiConfig";
import { motion, AnimatePresence } from "framer-motion";
import 'bootstrap/dist/css/bootstrap.min.css';

const BRAND = '#facc15';
const BRAND_RGB = '250,204,21';

const fadeUp = { hidden:{ opacity:0, y:20 }, show:{ opacity:1, y:0, transition:{ duration:0.5, ease:[0.22,1,0.36,1] } } };

const OPERADORAS = [
  { value: 'cielo',        label: 'Cielo',           categoria: 'adquirente' },
  { value: 'rede',         label: 'Rede',             categoria: 'adquirente' },
  { value: 'stone',        label: 'Stone',            categoria: 'adquirente' },
  { value: 'getnet',       label: 'GetNet',           categoria: 'adquirente' },
  { value: 'safrapay',     label: 'SafraPay',         categoria: 'adquirente' },
  { value: 'bin',          label: 'BIN / Vero',       categoria: 'adquirente' },
  { value: 'sicredi',      label: 'Sicredi',          categoria: 'adquirente' },
  { value: 'pagseguro',    label: 'PagSeguro',        categoria: 'subadquirente' },
  { value: 'mercadopago',  label: 'Mercado Pago',     categoria: 'subadquirente' },
  { value: 'sumup',        label: 'SumUp',            categoria: 'subadquirente' },
  { value: 'sipag',        label: 'Sipag',            categoria: 'subadquirente' },
  { value: 'american',     label: 'Amex',             categoria: 'bandeira' },
  { value: 'totvs',        label: 'TOTVS Payments',   categoria: 'subadquirente' },
  { value: 'cloudwalk',    label: 'InfinitePay',      categoria: 'subadquirente' },
  { value: 'outro',        label: 'Outro',            categoria: 'outro' },
];

const RATE_OPTIONS = [
  { key: 'pix',              label: 'PIX' },
  { key: 'debito',           label: 'Débito' },
  { key: 'credito_vista',    label: 'Crédito à Vista' },
  { key: 'credito_parcelado', label: 'Crédito Parcelado' },
];

const BANDEIRA_OPTIONS = [
  { key: 'mastercard',  label: 'Mastercard',    desc: 'Alta aceitação',              grupo: 'Principal' },
  { key: 'visa',        label: 'Visa',          desc: 'Alta aceitação',              grupo: 'Principal' },
  { key: 'elo',         label: 'Elo',           desc: 'Bandeira brasileira',         grupo: 'Principal' },
  { key: 'amex',        label: 'American Express', desc: 'Premium / alta renda',    grupo: 'Principal' },
  { key: 'hipercard',   label: 'Hipercard',     desc: 'Popular no varejo',           grupo: 'Principal' },
  { key: 'diners',      label: 'Diners Club',   desc: 'Internacional / benefícios',  grupo: 'Outras' },
  { key: 'sorocred',    label: 'Sorocred',      desc: 'Regional',                    grupo: 'Outras' },
  { key: 'elo_grafite', label: 'Elo Grafite',   desc: 'Elo categoria premium',       grupo: 'Elo Variantes' },
  { key: 'elo_nanquim', label: 'Elo Nanquim',   desc: 'Elo categoria top',           grupo: 'Elo Variantes' },
];

const VOUCHER_OPTIONS = [
  { key: 'alelo',     label: 'Alelo',           desc: 'Refeição e Alimentação' },
  { key: 'pluxee',    label: 'Pluxee (Sodexo)', desc: 'Refeição, Alimentação e Cultura' },
  { key: 'ticket',    label: 'Ticket',          desc: 'Refeição e Alimentação' },
  { key: 'vr',        label: 'VR',              desc: 'Refeição e Alimentação' },
  { key: 'up',        label: 'Up Brasil',       desc: 'Refeição e Alimentação' },
  { key: 'greencard', label: 'Greencard',       desc: 'Refeição e Alimentação' },
  { key: 'ben',       label: 'Ben Visa Vale',   desc: 'Alimentação' },
];

const CATEGORIAS = [
  { id: 'adquirente',    label: 'Adquirentes' },
  { id: 'subadquirente', label: 'Subadquirentes' },
  { id: 'bandeira',      label: 'Bandeiras' },
  { id: 'outro',         label: 'Outros' },
];

export default function Home() {
  const { getAuthHeaders } = useAuth();
  const [loading, setLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileType, setFileType] = useState('');
  const [analysisResult, setAnalysisResult] = useState(null);
  const [showRates, setShowRates] = useState(false);
  const [customRates, setCustomRates] = useState({
    pix:               0.0,
    debito:            1.23,
    credito_vista:     3.00,
    credito_parcelado: 3.23,
  });

  // Locação
  const [temLocacao, setTemLocacao] = useState(null);
  const [locacaoPeriodo, setLocacaoPeriodo] = useState('mensal');
  const [locacaoValor, setLocacaoValor] = useState('');

  // Antecipação
  const [antecipacaoAutorizada, setAntecipacaoAutorizada] = useState(null);
  const [antecipacaoTaxa, setAntecipacaoTaxa] = useState('');

  // Bandeiras por taxa
  const [bandeirasAtivas, setBandeirasAtivas] = useState({});
  const [bandeiraRates, setBandeiraRates] = useState({});

  // Vouchers
  const [vouchersAtivos, setVouchersAtivos] = useState({}); // { alelo: true, ... }
  const [voucherRates, setVoucherRates] = useState({}); // { alelo: 0 }

  // Proposta comercial
  const [temProposta, setTemProposta] = useState(null); // null | 'sim' | 'nao'
  const [propostaFile, setPropostaFile] = useState(null);
  const propostaInputRef = useRef(null);

  const fileInputRef = useRef(null);
  const step1Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);
  const [highlightStep, setHighlightStep] = useState(null);

  const handleRateChange = (key, valor) => {
    setCustomRates(prev => ({ ...prev, [key]: valor === '' ? '' : parseFloat(valor) }));
  };

  const handleVoucherToggle = (key) => {
    const isActive = !vouchersAtivos[key];
    setVouchersAtivos(prev => ({ ...prev, [key]: isActive }));
    if (!isActive) {
      setVoucherRates(prev => { const next = { ...prev }; delete next[key]; return next; });
    } else {
      setVoucherRates(prev => ({ ...prev, [key]: prev[key] ?? 0 }));
    }
  };

  const handleVoucherRateChange = (key, valor) => {
    setVoucherRates(prev => ({ ...prev, [key]: valor === '' ? '' : parseFloat(valor) }));
  };

  const handleBandeiraToggle = (key) => {
    const isActive = !bandeirasAtivas[key];
    setBandeirasAtivas(prev => ({ ...prev, [key]: isActive }));
    if (!isActive) {
      setBandeiraRates(prev => { const next = { ...prev }; delete next[key]; return next; });
    } else {
      setBandeiraRates(prev => ({ ...prev, [key]: prev[key] ?? '' }));
    }
  };

  const handleBandeiraRateChange = (key, valor) => {
    setBandeiraRates(prev => ({ ...prev, [key]: valor === '' ? '' : parseFloat(valor) }));
  };

  const handleBlockedClick = () => {
    if (isReady) return;
    let ref, num;
    if (!fileType)              { ref = step1Ref; num = 1; }
    else if (temLocacao === null)         { ref = step3Ref; num = 3; }
    else if (antecipacaoAutorizada === null) { ref = step4Ref; num = 4; }
    else                        { ref = step5Ref; num = 5; }
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setHighlightStep(num);
    setTimeout(() => setHighlightStep(null), 2500);
  };

  const handleFileTypeChange = (val) => {
    setFileType(val);
    setSelectedFile(null);
    setAnalysisResult(null);
    setUploadStatus(null);
  };

  const buildLocacaoConfig = () => {
    if (temLocacao === 'nao') return { tem_locacao: false };
    if (temLocacao === 'sim') return { tem_locacao: true, periodo: locacaoPeriodo, valor_contratado: parseFloat(locacaoValor) || 0 };
    return null;
  };

  const buildAntecipacaoConfig = () => {
    if (antecipacaoAutorizada === 'nao') return { autorizada: false };
    if (antecipacaoAutorizada === 'sim') return { autorizada: true, taxa_contratada: parseFloat(antecipacaoTaxa) || 0 };
    return null;
  };

  const buildBandeiraConfig = () => {
    const ativos = Object.keys(bandeirasAtivas).filter(k => bandeirasAtivas[k]);
    if (ativos.length === 0) return null;
    return ativos.map(k => {
      const t = parseFloat(bandeiraRates[k]) || 0;
      return { bandeira: BANDEIRA_OPTIONS.find(b => b.key === k)?.label || k, taxa_min: t, taxa_max: t };
    });
  };

  const buildVoucherConfig = () => {
    const ativos = Object.keys(vouchersAtivos).filter(k => vouchersAtivos[k]);
    if (ativos.length === 0) return null;
    return ativos.map(k => {
      const t = parseFloat(voucherRates[k]) || 0;
      return { bandeira: VOUCHER_OPTIONS.find(v => v.key === k)?.label || k, taxa_min: t, taxa_max: t };
    });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!fileType) {
      setUploadStatus({ type: 'error', message: 'Selecione a operadora antes de enviar o arquivo.' });
      return;
    }
    if (temLocacao === null) {
      setUploadStatus({ type: 'error', message: 'Informe se há cobrança de locação de maquininha (Passo 3).' });
      return;
    }
    if (antecipacaoAutorizada === null) {
      setUploadStatus({ type: 'error', message: 'Informe se a antecipação é autorizada (Passo 4).' });
      return;
    }

    setSelectedFile(file);
    setLoading(true);
    setUploadStatus(null);
    setAnalysisResult(null);

    try {
      const formData = new FormData();
      formData.append('csvFile', file);
      formData.append('fileType', fileType);
      // Converte taxa única para range {min,max} que o backend valida
      const normalizedRates = Object.fromEntries(
        Object.entries(customRates).map(([k, v]) => { const t = parseFloat(v) || 0; return [k, { min: t, max: t }]; })
      );
      formData.append('customRates', JSON.stringify(normalizedRates));
      formData.append('locacao', JSON.stringify(buildLocacaoConfig()));
      formData.append('antecipacao', JSON.stringify(buildAntecipacaoConfig()));
      const voucherConfig = buildVoucherConfig();
      if (voucherConfig) formData.append('vouchers', JSON.stringify(voucherConfig));
      const bandeiraConfig = buildBandeiraConfig();
      if (bandeiraConfig) formData.append('bandeiras', JSON.stringify(bandeiraConfig));
      if (temProposta === 'sim' && propostaFile) formData.append('proposta', propostaFile);

      const response = await fetch(apiUrl('/api/upload'), {
        method: 'POST',
        body: formData,
        headers: getAuthHeaders(),
      });
      const result = await response.json();

      if (response.ok) {
        const hasAiError = Boolean(result.analysisError);
        setAnalysisResult(result.analysis || null);
        const isRestrito = result.acesso_completo === false;
        setUploadStatus({
          type: hasAiError ? 'warning' : 'success',
          message: hasAiError
            ? `Arquivo salvo, mas ocorreu um erro na análise: ${result.analysisError}`
            : isRestrito
              ? `Análise concluída — seu plano exibe apenas o sumário. Fale com a Brasil Soluções para liberar o laudo completo.`
              : `Análise concluída para "${result.upload.filename}".`,
        });
      } else {
        setUploadStatus({ type: 'error', message: result.error || 'Falha desconhecida' });
      }
    } catch (error) {
      setUploadStatus({ type: 'error', message: `Erro: ${error.message}` });
    } finally {
      setLoading(false);
      // Limpa o input para permitir reenviar o mesmo arquivo
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const selectedOp = OPERADORAS.find(o => o.value === fileType);
  const categoriaLabel = CATEGORIAS.find(c => c.id === selectedOp?.categoria)?.label || '';
  const isReady = fileType && temLocacao !== null && antecipacaoAutorizada !== null &&
    temProposta !== null &&
    (temLocacao !== 'sim' || (locacaoValor !== '' && !isNaN(parseFloat(locacaoValor)))) &&
    (antecipacaoAutorizada !== 'sim' || (antecipacaoTaxa !== '' && !isNaN(parseFloat(antecipacaoTaxa)))) &&
    (temProposta !== 'sim' || propostaFile !== null);

  return (
    <div style={{ minHeight:'100vh', background:'#020617', color:'#f1f5f9', fontFamily:'Inter, system-ui, sans-serif' }}>
      <style>{`
        * { box-sizing: border-box; }
        .select-dark { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #f1f5f9; border-radius: 12px; padding: 12px 16px; font-size: 0.95rem; width: 100%; transition: all 0.2s; cursor: pointer; }
        .input-rate { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #f1f5f9; border-radius: 10px; padding: 10px 12px; font-size: 0.875rem; width: 100%; transition: all 0.2s; }
        .input-rate:focus { outline: none; border-color: rgba(250,204,21,0.4); }
        .input-rate::placeholder { color: rgba(241,245,249,0.3); }
        .btn-ghost { background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); color: rgba(241,245,249,0.7); border-radius: 12px; padding: 13px 24px; font-weight: 600; font-size: 0.9rem; cursor: pointer; transition: all 0.2s; display: inline-flex; align-items: center; gap: 8px; }
        .btn-ghost:hover { background: rgba(255,255,255,0.1); }
        .op-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 11px 14px; cursor: pointer; transition: all 0.2s; text-align: center; }
        .op-card:hover { border-color: rgba(250,204,21,0.3); background: rgba(250,204,21,0.04); }
        .op-card.selected { border-color: rgba(250,204,21,0.6); background: rgba(250,204,21,0.08); }
        .toggle-btn { border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 10px 20px; font-size: 0.88rem; font-weight: 600; cursor: pointer; transition: all 0.2s; background: transparent; }
        .toggle-btn.active-sim { background: rgba(16,185,129,0.15); border-color: rgba(16,185,129,0.4); color: #6ee7b7; }
        .toggle-btn.active-nao { background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.35); color: #fca5a5; }
        .toggle-btn.inactive { background: rgba(255,255,255,0.04); color: rgba(241,245,249,0.5); }
        .toggle-btn.active-periodo { background: rgba(250,204,21,0.12); border-color: rgba(250,204,21,0.4); color: ${BRAND}; }
        .voucher-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 12px 16px; cursor: pointer; transition: all 0.2s; }
        .voucher-card:hover { border-color: rgba(99,179,237,0.35); background: rgba(99,179,237,0.04); }
        .voucher-card.active { border-color: rgba(99,179,237,0.55); background: rgba(99,179,237,0.1); }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse-border { 0%,100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.5); } 50% { box-shadow: 0 0 0 8px rgba(239,68,68,0); } }
        .step-highlight { border-color: rgba(239,68,68,0.7) !important; background: rgba(239,68,68,0.05) !important; animation: pulse-border 0.7s ease 3; }
      `}</style>

      <AppBarComponent />

      <div style={{ maxWidth:960, margin:'0 auto', padding:'40px 24px' }}>

        {/* Header */}
        <motion.div initial="hidden" animate="show" variants={{ show:{ transition:{ staggerChildren:0.07 } } }} style={{ marginBottom:36 }}>
          <motion.div variants={fadeUp}>
            <span style={{ display:'inline-block', background:`rgba(${BRAND_RGB},0.08)`, border:`1px solid rgba(${BRAND_RGB},0.25)`, borderRadius:100, padding:'5px 16px', fontSize:'0.7rem', fontWeight:700, color:BRAND, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:14 }}>
              Análise de Taxas com IA
            </span>
          </motion.div>
          <motion.h1 variants={fadeUp} style={{ fontSize:'clamp(1.6rem,4vw,2.2rem)', fontWeight:900, marginBottom:8 }}>
            Audite seu extrato de maquininha
          </motion.h1>
          <motion.p variants={fadeUp} style={{ color:'rgba(241,245,249,0.5)', fontSize:'1rem', margin:0 }}>
            Selecione a operadora, configure taxas, locação, antecipação e vouchers para auditoria completa.
          </motion.p>
        </motion.div>

        <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.5, delay:0.1 }}>
          <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:20, padding:32, marginBottom:24 }}>

            {/* Passo 1 — Operadora */}
            <div ref={step1Ref} className={highlightStep === 1 ? 'step-highlight' : ''} style={{ marginBottom:28, borderRadius:14, padding: highlightStep === 1 ? '16px' : '0', border: highlightStep === 1 ? '1px solid' : 'none', transition:'all 0.3s' }}>
              <StepHeader number={1} title="Selecione a operadora / adquirente" required={!fileType} />
              {CATEGORIAS.filter(cat => OPERADORAS.some(o => o.categoria === cat.id)).map(cat => (
                <div key={cat.id} style={{ marginBottom:14 }}>
                  <div style={{ fontSize:'0.7rem', fontWeight:700, color:'rgba(241,245,249,0.3)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:8 }}>{cat.label}</div>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                    {OPERADORAS.filter(o => o.categoria === cat.id).map(op => (
                      <div key={op.value} className={`op-card ${fileType === op.value ? 'selected' : ''}`} onClick={() => handleFileTypeChange(op.value)} style={{ minWidth:100 }}>
                        <div style={{ fontWeight:700, fontSize:'0.82rem', color: fileType === op.value ? BRAND : '#f1f5f9' }}>{op.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              {selectedOp && (
                <div style={{ marginTop:8, padding:'9px 14px', background:'rgba(250,204,21,0.05)', border:'1px solid rgba(250,204,21,0.15)', borderRadius:10, fontSize:'0.8rem', color:'rgba(241,245,249,0.6)' }}>
                  ℹ️ <strong style={{ color:BRAND }}>{selectedOp.label}</strong> — {categoriaLabel} · CSV separado por ponto e vírgula (;)
                </div>
              )}
            </div>

            <Divider />

            {/* Passo 2 — Taxas */}
            <div style={{ marginBottom:28 }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
                <StepHeader number={2} title="Taxas contratuais" inline />
                <button className="btn-ghost" style={{ padding:'7px 14px', fontSize:'0.8rem' }} onClick={() => setShowRates(!showRates)}>
                  {showRates ? '▲ Ocultar' : '⚙ Configurar taxas'}
                </button>
              </div>
              {showRates && (
                <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:14, padding:20 }}>
                  <div className="row g-3">
                    {RATE_OPTIONS.map(r => (
                      <div key={r.key} className="col-sm-6 col-lg-3">
                        <div style={{ marginBottom:8, fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em' }}>{r.label}</div>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                          <input className="input-rate" type="number" step="0.01" min="0" value={customRates[r.key]} onChange={e => handleRateChange(r.key, e.target.value)} placeholder="0.00"/>
                          <span style={{ color:'rgba(241,245,249,0.4)', fontSize:'0.85rem', flexShrink:0 }}>%</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!showRates && (
                <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                  {RATE_OPTIONS.map(r => (
                    <span key={r.key} style={{ background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, padding:'5px 12px', fontSize:'0.75rem', color:'rgba(241,245,249,0.5)' }}>
                      {r.label}: <strong style={{ color:'rgba(241,245,249,0.8)' }}>{customRates[r.key]}%</strong>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <Divider />

            {/* Passo 3 — Locação */}
            <div ref={step3Ref} className={highlightStep === 3 ? 'step-highlight' : ''} style={{ marginBottom:28, borderRadius:14, padding: highlightStep === 3 ? '16px' : '0', border: highlightStep === 3 ? '1px solid' : 'none', transition:'all 0.3s' }}>
              <StepHeader number={3} title="Locação de maquininha" required={temLocacao === null} />
              <p style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.45)', margin:'0 0 14px' }}>
                Há cobrança de aluguel/locação de terminal no extrato?
              </p>
              <div style={{ display:'flex', gap:10 }}>
                <button className={`toggle-btn ${temLocacao === 'sim' ? 'active-sim' : 'inactive'}`} onClick={() => setTemLocacao('sim')}>✓ Sim, há locação</button>
                <button className={`toggle-btn ${temLocacao === 'nao' ? 'active-nao' : 'inactive'}`} onClick={() => setTemLocacao('nao')}>✕ Não há locação</button>
              </div>
              <AnimatePresence>
                {temLocacao === 'sim' && (
                  <motion.div initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.25 }}>
                    <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, padding:20, marginTop:14 }}>
                      <div style={{ marginBottom:16 }}>
                        <div style={{ fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:10 }}>Periodicidade</div>
                        <div style={{ display:'flex', gap:10 }}>
                          <button className={`toggle-btn ${locacaoPeriodo === 'mensal' ? 'active-periodo' : 'inactive'}`} onClick={() => setLocacaoPeriodo('mensal')}>Mensal</button>
                          <button className={`toggle-btn ${locacaoPeriodo === 'anual' ? 'active-periodo' : 'inactive'}`} onClick={() => setLocacaoPeriodo('anual')}>Anual</button>
                        </div>
                      </div>
                      <div style={{ maxWidth:260 }}>
                        <div style={{ fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:8 }}>
                          Valor contratado (R$/{locacaoPeriodo === 'mensal' ? 'mês' : 'ano'})
                        </div>
                        <input className="input-rate" type="number" step="0.01" min="0" placeholder="Ex: 59.90" value={locacaoValor} onChange={e => setLocacaoValor(e.target.value)}/>
                        <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.3)', marginTop:6 }}>A IA verificará valor cobrado, cobranças indevidas por mês e divergências de parcelas.</div>
                      </div>
                    </div>
                  </motion.div>
                )}
                {temLocacao === 'nao' && (
                  <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }} style={{ marginTop:12, padding:'10px 14px', background:'rgba(16,185,129,0.06)', border:'1px solid rgba(16,185,129,0.2)', borderRadius:10, fontSize:'0.8rem', color:'rgba(110,231,183,0.8)' }}>
                    ✓ A IA irá alertar caso encontre qualquer cobrança de locação no extrato.
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Divider />

            {/* Passo 4 — Antecipação */}
            <div ref={step4Ref} className={highlightStep === 4 ? 'step-highlight' : ''} style={{ marginBottom:28, borderRadius:14, padding: highlightStep === 4 ? '16px' : '0', border: highlightStep === 4 ? '1px solid' : 'none', transition:'all 0.3s' }}>
              <StepHeader number={4} title="Antecipação de recebíveis (ARV)" required={antecipacaoAutorizada === null} />
              <p style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.45)', margin:'0 0 14px' }}>
                A antecipação de recebíveis está autorizada no contrato?
              </p>
              <div style={{ display:'flex', gap:10 }}>
                <button className={`toggle-btn ${antecipacaoAutorizada === 'sim' ? 'active-sim' : 'inactive'}`} onClick={() => setAntecipacaoAutorizada('sim')}>✓ Autorizada</button>
                <button className={`toggle-btn ${antecipacaoAutorizada === 'nao' ? 'active-nao' : 'inactive'}`} onClick={() => setAntecipacaoAutorizada('nao')}>✕ Não autorizada</button>
              </div>
              <AnimatePresence>
                {antecipacaoAutorizada === 'nao' && (
                  <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }} style={{ marginTop:12, padding:'12px 16px', background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.25)', borderRadius:10, fontSize:'0.82rem', color:'#fca5a5' }}>
                    ⚠ A IA irá identificar e alertar sobre <strong>toda e qualquer antecipação</strong> encontrada como cobrança indevida.
                  </motion.div>
                )}
                {antecipacaoAutorizada === 'sim' && (
                  <motion.div initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.25 }}>
                    <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, padding:20, marginTop:14 }}>
                      <div style={{ maxWidth:280 }}>
                        <div style={{ fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:8 }}>
                          Taxa de antecipação contratada (% ao mês)
                        </div>
                        <input className="input-rate" type="number" step="0.01" min="0" placeholder="Ex: 1.99" value={antecipacaoTaxa} onChange={e => setAntecipacaoTaxa(e.target.value)}/>
                        <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.3)', marginTop:6 }}>
                          A IA calculará o custo efetivo por prazo e alertará sobre spread abusivo ou capitalização indevida.
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Divider />

            {/* Passo 5 — Proposta Comercial */}
            <div ref={step5Ref} className={highlightStep === 5 ? 'step-highlight' : ''} style={{ marginBottom:28, borderRadius:14, padding: highlightStep === 5 ? '16px' : '0', border: highlightStep === 5 ? '1px solid' : 'none', transition:'all 0.3s' }}>
              <StepHeader number={5} title="Cópia da proposta comercial" required={temProposta === null || (temProposta === 'sim' && !propostaFile)} />
              <p style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.45)', margin:'0 0 14px' }}>
                Você tem cópia da proposta enviada pela operadora? A IA irá comparar as taxas da proposta com as do extrato antes de calcular.
              </p>
              <div style={{ display:'flex', gap:10, marginBottom:12 }}>
                <button className={`toggle-btn ${temProposta === 'sim' ? 'active-sim' : 'inactive'}`} onClick={() => { setTemProposta('sim'); setPropostaFile(null); }}>✓ Sim, tenho</button>
                <button className={`toggle-btn ${temProposta === 'nao' ? 'active-nao' : 'inactive'}`} onClick={() => { setTemProposta('nao'); setPropostaFile(null); }}>✕ Não tenho</button>
              </div>
              <AnimatePresence>
                {temProposta === 'sim' && (
                  <motion.div initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.25 }}>
                    <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, padding:20, marginTop:4 }}>
                      <div style={{ fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:10 }}>Anexar proposta (PDF, imagem ou CSV)</div>
                      <label style={{ display:'inline-block', cursor:'pointer' }}>
                        <input ref={propostaInputRef} type="file" accept=".pdf,.csv,.jpg,.jpeg,.png,.webp,.doc,.docx" style={{ display:'none' }}
                          onChange={e => setPropostaFile(e.target.files[0] || null)}/>
                        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                          <div style={{ background:`rgba(250,204,21,0.1)`, border:`1px solid rgba(250,204,21,0.3)`, borderRadius:10, padding:'9px 18px', fontSize:'0.85rem', fontWeight:700, color:'#facc15', display:'inline-flex', alignItems:'center', gap:8 }}>
                            📎 {propostaFile ? 'Trocar arquivo' : 'Selecionar arquivo'}
                          </div>
                          {propostaFile && (
                            <div style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.6)', display:'flex', alignItems:'center', gap:8 }}>
                              <span style={{ color:'#6ee7b7' }}>✓</span>
                              <span style={{ maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{propostaFile.name}</span>
                              <button type="button" onClick={e => { e.preventDefault(); setPropostaFile(null); if(propostaInputRef.current) propostaInputRef.current.value=''; }}
                                style={{ background:'transparent', border:'none', color:'rgba(241,245,249,0.4)', cursor:'pointer', fontSize:'1rem', padding:0, lineHeight:1 }}>✕</button>
                            </div>
                          )}
                        </div>
                      </label>
                      {!propostaFile && (
                        <div style={{ fontSize:'0.72rem', color:'rgba(239,68,68,0.7)', marginTop:8 }}>⬤ Anexe o arquivo da proposta para continuar</div>
                      )}
                      <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.3)', marginTop:10 }}>
                        A IA comparará as taxas prometidas na proposta com as efetivamente cobradas no extrato, identificando divergências entre o que foi vendido e o que foi aplicado.
                      </div>
                    </div>
                  </motion.div>
                )}
                {temProposta === 'nao' && (
                  <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }} style={{ marginTop:8, padding:'10px 14px', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:10, fontSize:'0.8rem', color:'rgba(241,245,249,0.45)' }}>
                    ℹ A análise será feita com base apenas nas taxas informadas acima. Recomendamos solicitar uma cópia da proposta à operadora para auditoria completa.
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Divider />

            {/* Passo 6 — Bandeiras por taxa */}
            <div style={{ marginBottom:28 }}>
              <StepHeader number={6} title="Taxas por bandeira (MDR específico)" />
              <p style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.45)', margin:'0 0 14px' }}>
                Se o seu contrato tem taxas diferentes por bandeira (ex: Visa diferente de Mastercard), selecione e informe. (opcional)
              </p>
              {/* Grupos de bandeiras */}
              {['Principal', 'Outras', 'Elo Variantes'].map(grupo => {
                const opcoes = BANDEIRA_OPTIONS.filter(b => b.grupo === grupo);
                return (
                  <div key={grupo} style={{ marginBottom:12 }}>
                    <div style={{ fontSize:'0.68rem', fontWeight:700, color:'rgba(241,245,249,0.3)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:8 }}>{grupo}</div>
                    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                      {opcoes.map(b => (
                        <div key={b.key}
                          onClick={() => handleBandeiraToggle(b.key)}
                          style={{
                            background: bandeirasAtivas[b.key] ? 'rgba(168,85,247,0.12)' : 'rgba(255,255,255,0.03)',
                            border: `1px solid ${bandeirasAtivas[b.key] ? 'rgba(168,85,247,0.5)' : 'rgba(255,255,255,0.08)'}`,
                            borderRadius:12, padding:'10px 14px', cursor:'pointer', transition:'all 0.2s',
                          }}>
                          <div style={{ fontWeight:700, fontSize:'0.82rem', color: bandeirasAtivas[b.key] ? '#c4b5fd' : '#f1f5f9', marginBottom:2 }}>{b.label}</div>
                          <div style={{ fontSize:'0.65rem', color:'rgba(241,245,249,0.35)' }}>{b.desc}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
              <AnimatePresence>
                {BANDEIRA_OPTIONS.some(b => bandeirasAtivas[b.key]) && (
                  <motion.div initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.25 }}>
                    <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, padding:20, marginTop:12 }}>
                      <div style={{ fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:14 }}>
                        Taxa contratada por bandeira (%)
                      </div>
                      <div className="row g-3">
                        {BANDEIRA_OPTIONS.filter(b => bandeirasAtivas[b.key]).map(b => (
                          <div key={b.key} className="col-sm-6 col-lg-4">
                            <div style={{ fontSize:'0.82rem', fontWeight:600, color:'#c4b5fd', marginBottom:8 }}>{b.label}</div>
                            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                              <input className="input-rate" type="number" step="0.01" min="0" placeholder="0.00"
                                value={bandeiraRates[b.key] ?? ''}
                                onChange={e => handleBandeiraRateChange(b.key, e.target.value)}/>
                              <span style={{ color:'rgba(241,245,249,0.4)', fontSize:'0.85rem', flexShrink:0 }}>%</span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.3)', marginTop:14 }}>
                        A IA verificará se a taxa MDR cobrada por bandeira corresponde ao valor contratado, identificando reclassificações silenciosas (ex: cartão comum tratado como Premium).
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Divider />

            {/* Passo 7 — Vouchers */}
            <div style={{ marginBottom:28 }}>
              <StepHeader number={7} title="Cartões voucher / benefício" />
              <p style={{ fontSize:'0.82rem', color:'rgba(241,245,249,0.45)', margin:'0 0 14px' }}>
                Selecione as bandeiras de voucher aceitas e informe as taxas contratuais. (opcional)
              </p>
              <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:16 }}>
                {VOUCHER_OPTIONS.map(v => (
                  <div key={v.key} className={`voucher-card ${vouchersAtivos[v.key] ? 'active' : ''}`} onClick={() => handleVoucherToggle(v.key)} style={{ cursor:'pointer' }}>
                    <div style={{ fontWeight:700, fontSize:'0.82rem', color: vouchersAtivos[v.key] ? '#93c5fd' : '#f1f5f9', marginBottom:2 }}>{v.label}</div>
                    <div style={{ fontSize:'0.65rem', color:'rgba(241,245,249,0.35)' }}>{v.desc}</div>
                  </div>
                ))}
              </div>
              <AnimatePresence>
                {VOUCHER_OPTIONS.some(v => vouchersAtivos[v.key]) && (
                  <motion.div initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.25 }}>
                    <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, padding:20 }}>
                      <div style={{ fontSize:'0.78rem', fontWeight:600, color:'rgba(241,245,249,0.5)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:14 }}>
                        Taxas contratuais por bandeira (%)
                      </div>
                      <div className="row g-3">
                        {VOUCHER_OPTIONS.filter(v => vouchersAtivos[v.key]).map(v => (
                          <div key={v.key} className="col-sm-6 col-lg-4">
                            <div style={{ fontSize:'0.82rem', fontWeight:600, color:'#93c5fd', marginBottom:8 }}>{v.label}</div>
                            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                              <input className="input-rate" type="number" step="0.01" min="0" placeholder="0.00" value={voucherRates[v.key] ?? ''} onChange={e => handleVoucherRateChange(v.key, e.target.value)}/>
                              <span style={{ color:'rgba(241,245,249,0.4)', fontSize:'0.85rem', flexShrink:0 }}>%</span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ fontSize:'0.72rem', color:'rgba(241,245,249,0.3)', marginTop:14 }}>
                        A IA verificará se as taxas cobradas nas transações de voucher correspondem aos valores contratados para cada bandeira, sem acréscimos ou arredondamentos indevidos.
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Divider />

            {/* Passo 8 — Upload */}
            <div>
              <StepHeader number={8} title="Upload do arquivo CSV" />
              <label style={{ display:'block' }} onClick={!isReady ? handleBlockedClick : undefined}>
                <input ref={fileInputRef} type="file" accept=".csv" style={{ display:'none' }} onChange={handleFileUpload} disabled={loading || !isReady}/>
                <div style={{
                  border:`2px dashed ${!isReady ? 'rgba(239,68,68,0.25)' : `rgba(${BRAND_RGB},0.25)`}`,
                  borderRadius:16, padding:'32px 24px', textAlign:'center',
                  cursor: isReady ? 'pointer' : 'pointer',
                  transition:'all 0.2s',
                  background: isReady ? `rgba(${BRAND_RGB},0.03)` : 'rgba(239,68,68,0.03)'
                }}>
                  {loading ? (
                    <div>
                      <div style={{ width:40, height:40, border:'3px solid rgba(255,255,255,0.1)', borderTopColor:BRAND, borderRadius:'50%', animation:'spin 0.8s linear infinite', margin:'0 auto 12px' }}/>
                      <div style={{ fontWeight:600, color:BRAND }}>Analisando com IA...</div>
                      <div style={{ fontSize:'0.8rem', color:'rgba(241,245,249,0.4)', marginTop:4 }}>O Gemini está processando cada transação</div>
                    </div>
                  ) : selectedFile ? (
                    <div>
                      <div style={{ fontSize:'2rem', marginBottom:8 }}>✅</div>
                      <div style={{ fontWeight:600, color:'#f1f5f9' }}>{selectedFile.name}</div>
                      <div style={{ fontSize:'0.8rem', color:'rgba(241,245,249,0.4)', marginTop:4 }}>{(selectedFile.size/1024).toFixed(1)} KB</div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize:'2.5rem', marginBottom:10 }}>📤</div>
                      <div style={{ fontWeight:600, color: isReady ? '#f1f5f9' : 'rgba(241,245,249,0.3)', marginBottom:8 }}>
                        {isReady ? 'Clique para selecionar o CSV' : 'Complete os passos abaixo para liberar o upload'}
                      </div>
                      {!isReady && (
                        <div style={{ display:'flex', flexDirection:'column', gap:4, marginBottom:8, textAlign:'left', maxWidth:320, margin:'0 auto 8px' }}>
                          {!fileType && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 1: Selecione a operadora</div>}
                          {temLocacao === null && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 3: Informe sobre locação</div>}
                          {temLocacao === 'sim' && (locacaoValor === '' || isNaN(parseFloat(locacaoValor))) && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 3: Informe o valor de locação</div>}
                          {antecipacaoAutorizada === null && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 4: Informe sobre antecipação</div>}
                          {antecipacaoAutorizada === 'sim' && (antecipacaoTaxa === '' || isNaN(parseFloat(antecipacaoTaxa))) && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 4: Informe a taxa de antecipação</div>}
                          {temProposta === null && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 5: Informe sobre a proposta comercial</div>}
                          {temProposta === 'sim' && !propostaFile && <div style={{ fontSize:'0.75rem', color:'rgba(239,68,68,0.8)', display:'flex', alignItems:'center', gap:6 }}>⬤ Passo 5: Anexe o arquivo da proposta</div>}
                        </div>
                      )}
                      <div style={{ fontSize:'0.8rem', color:'rgba(241,245,249,0.35)' }}>Apenas arquivos .csv</div>
                    </div>
                  )}
                </div>
              </label>
            </div>

            {/* Status */}
            {uploadStatus && (
              <div style={{ marginTop:16, padding:'14px 18px', borderRadius:12,
                background: uploadStatus.type === 'success' ? 'rgba(16,185,129,0.1)' : uploadStatus.type === 'warning' ? 'rgba(245,158,11,0.1)' : 'rgba(239,68,68,0.1)',
                border: `1px solid ${uploadStatus.type === 'success' ? 'rgba(16,185,129,0.3)' : uploadStatus.type === 'warning' ? 'rgba(245,158,11,0.3)' : 'rgba(239,68,68,0.3)'}`,
                color: uploadStatus.type === 'success' ? '#6ee7b7' : uploadStatus.type === 'warning' ? '#fcd34d' : '#fca5a5',
                fontSize:'0.875rem', display:'flex', alignItems:'center', gap:10 }}>
                {uploadStatus.type === 'success' ? '✓' : uploadStatus.type === 'warning' ? '⚠' : '✕'} {uploadStatus.message}
              </div>
            )}
          </div>
        </motion.div>

        {/* Resultado */}
        {analysisResult && (
          <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.5 }}>
            <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:20, padding:32 }}>
              <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20 }}>
                <div style={{ width:36, height:36, borderRadius:10, background:`rgba(${BRAND_RGB},0.12)`, border:`1px solid rgba(${BRAND_RGB},0.25)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem' }}>🤖</div>
                <div>
                  <div style={{ fontWeight:800, fontSize:'1.05rem' }}>Relatório de Análise — {selectedOp?.label}</div>
                  <div style={{ fontSize:'0.78rem', color:'rgba(241,245,249,0.4)' }}>Gerado pelo Gemini AI</div>
                </div>
              </div>
              <div style={{ background:'rgba(0,0,0,0.3)', borderRadius:12, padding:24, fontFamily:'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize:'0.82rem', lineHeight:1.75, color:'rgba(241,245,249,0.85)', whiteSpace:'pre-wrap', maxHeight:700, overflowY:'auto', border:'1px solid rgba(255,255,255,0.05)' }}>
                {analysisResult}
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}

function StepHeader({ number, title, inline, required }) {
  const BR = '#facc15';
  const BRR = '250,204,21';
  const numBg = required ? 'rgba(239,68,68,0.2)' : `rgba(${BRR},0.12)`;
  const numBorder = required ? 'rgba(239,68,68,0.5)' : `rgba(${BRR},0.25)`;
  const numColor = required ? '#fca5a5' : BR;
  if (inline) {
    return (
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ width:28, height:28, borderRadius:8, background:numBg, border:`1px solid ${numBorder}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.8rem', fontWeight:800, color:numColor, flexShrink:0 }}>{number}</div>
        <span style={{ fontWeight:700, fontSize:'0.95rem' }}>{title}</span>
        {required && <span style={{ fontSize:'0.65rem', fontWeight:700, color:'#fca5a5', background:'rgba(239,68,68,0.12)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:6, padding:'2px 8px', textTransform:'uppercase', letterSpacing:'0.06em' }}>obrigatório</span>}
      </div>
    );
  }
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16 }}>
      <div style={{ width:28, height:28, borderRadius:8, background:numBg, border:`1px solid ${numBorder}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.8rem', fontWeight:800, color:numColor, flexShrink:0 }}>{number}</div>
      <span style={{ fontWeight:700, fontSize:'0.95rem' }}>{title}</span>
      {required && <span style={{ fontSize:'0.65rem', fontWeight:700, color:'#fca5a5', background:'rgba(239,68,68,0.12)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:6, padding:'2px 8px', textTransform:'uppercase', letterSpacing:'0.06em' }}>obrigatório</span>}
    </div>
  );
}

function Divider() {
  return <div style={{ height:1, background:'rgba(255,255,255,0.06)', margin:'0 0 28px' }} />;
}
